<div class="text-center" style="min-width: max-content">
  <span *ngIf="label">{{label}} kgs.</span>
  <div class="tolva_padre" [style.height.px]="height" [style.width.px]="width" (click)="click()">
    <div class="border" [style.height.px]="height" [style.width.px]="width">
      <div class="tolva" [class]="validateColor(percent)">
        <div
          class="llenado wave animated animate__pulse"
          [style.height.%]="validateValue(percent)"
        ></div>
      </div>
    </div>
  </div>
</div>
